import React from "react";

export const BranchDetailContext = React.createContext(null);

export const useBranchDetailContext = () => {
  const context = React.useContext(BranchDetailContext);

  if (!context) throw new Error("Branch Detail Context not provided!");

  return context;
};
